import { Calendar } from "@fullcalendar/core";
import interactionPlugin from "@fullcalendar/interaction";
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import 'bootstrap/js/dist/modal';

export class DayCalendar {
  // resource（コマ）を表示しているヘッダーに付与するクラス名
  static resourceHeaderClassName = 'resource-timegrid-calendar-resource-header';
  // 上記ヘッダーの内側の要素のクラス名
  static resourceHeaderInnerClassName = 'fc-scrollgrid-sync-inner'
  // resource（コマ）全件表示の際、ヘッダーに付与するクラス名
  static viewAllResourceHeaderClassName = 'view-all-resource-header'
  // resource（コマ）一件表示の際、ヘッダーに付与するクラス名
  static selectedResourceHeaderClassName = 'selected-resource-header'
  // モーダルの開閉を管理(二重で開かないようにする)
  static isModalOpen = false;

  static generate() {
    let calendarEl = document.getElementById("day-calendar");
    if (calendarEl == null) { return }
    let calendarEvents = $('#calendar-events').data('events');
    let resources = $('#calendar-staffs').data('staffs');
    let breakTimes = $('#calendar-break-times').data('break-times');
    let date = $('#calendar-date').data('date');
    let initData = $('#calendar-init').data('init');
    let komaTime = initData["koma_time"];
    let startTime = initData["start_time"];
    let endTime = initData["end_time"];

    let scrollTime = this._setScrollTime(date, startTime)

    let calendar = new Calendar(calendarEl, {
      height: this._height(),
      schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives', // TODO
      plugins: [interactionPlugin, resourceTimeGridPlugin],
      initialView: "resourceTimeGridDay",
      headerToolbar: { left: "", center: "", right: "", },
      initialDate: date,
      scrollTime: scrollTime,
      slotDuration: `00:${komaTime}:00`,
      slotMinTime: startTime,
      slotMaxTime: endTime,
      locale: "ja",
      editable: false,
      eventResourceEditable: true,
      eventStartEditable: true,
      eventDrop: this._eventDrop(this),
      resources: resources,
      resourceOrder: 'order',
      events: calendarEvents,
      eventContent: this._eventContent(),
      eventDidMount: this._eventDidMount(),
      slotEventOverlap: false,
      allDaySlot: false,
      slotLabelInterval: `00:${komaTime}:00`,
      slotLabelFormat: {
        hour: '2-digit',
        minute: '2-digit',
        meridiem: false,
        hour12: false
      },
      slotLaneClassNames: this._addClassFutureBreaksSlotLane(date, breakTimes),
      resourceLabelClassNames: this.resourceHeaderClassName,
      eventClick: this._eventClick(),
      eventOrder: "type", // 登録イベントが右側に来るようにする
    });

    calendar.render();

    // カレンダーのheaderにクリックリスナーを仕込む
    this._selectResource(resources, calendar)

    // カレンダーのheaderに全件表示の際のクラスを当てる
    this._resourceHeaderAddClass()

    // シフトがお休みのスタッフのカレンダーにクラスを当てる
    this._addClassUnscheduledStaffResource(calendar)

    return calendar;
  }

  static _height() {
    let documentHeight = document.documentElement.offsetHeight
    // 比率で余白を決めるようにする
    let marginSize = documentHeight / 5.5
    return documentHeight - marginSize
  }

  static _setScrollTime(date, startTime) {
    let selectedDate = new Date(`${date} ${startTime}`);
    let currentDate = new Date();

    if (this._isSelectedDayToday(selectedDate, currentDate)) {
      if (selectedDate >= currentDate) {
        return startTime
      } else {
        let currentHours = currentDate.getHours()
        let currentMinutes = currentDate.getMinutes()
        let currentSeconds = currentDate.getSeconds()
        // scrollTimeに指定する際、一桁の数字だと正常に動作しないためゼロパディングを行う
        return `${this._zeroPadding(currentHours)}:${this._zeroPadding(currentMinutes)}:${this._zeroPadding(currentSeconds)}`
      }
    } else {
      return startTime
    }
  }

  static _eventContent() {
    const registrationEvent = this._registrationEvent;
    const calendarEvent = this._calendarEvent;
    const statusCard = this._statusCard
    return function (arg) {
      let extendedProps = arg.event.extendedProps
      let type = extendedProps.type
      if (type == 'registration') {
        return registrationEvent(extendedProps);
      } else {
        return calendarEvent(statusCard, extendedProps);
      }
    }
  };

  // Waitlist登録用のボタンをカレンダーのeventとして生成
  static _registrationEvent(extendedProps) {
    let eventContent = `
      <a class="btn btn-calendar-day modal-open js-btn-add-waitlist" data-toggle="modal" data-target="#newWaitlistModal" data-date="${extendedProps.date}" data-is-am=${extendedProps.am} data-is-pm=${extendedProps.pm} data-staff-id=${extendedProps.staff_id} href="#">+</a>
    `;
    return { html: eventContent }
  };

  // Waitlistの情報をまとめたカレンダーのevent
  static _calendarEvent(statusCard, extendedProps) {
    let isNewArrival = extendedProps.is_new_arrival
    let isUpdateMedicalAnswer = extendedProps.is_update_medical_answer
    // 未読用のマーク
    let newArrival = !!(isNewArrival || isUpdateMedicalAnswer) ? '<div class="recent-arrival-batch d-flex align-items-center"></div>' : '';

    let lineIconImage = "/assets/iconmonstr-line-3-48.png";
    let smsIconImage = "/assets/iconmonstr-sms-1-48.png";
    let iconImage = extendedProps.wait_type == "sms" ? smsIconImage : lineIconImage;
    // アイコン（ナカマチの場合はアイコンなし）
    let waitTypeIcon = extendedProps.wait_type != "inside" ? `<img class="mr-1" height="20px" src="${iconImage}" style="width:20px;">` : '';
    // 電子カルテ連携用のアイコン
    let linkedIcon = DayCalendar._emrStatusIcon(extendedProps);

    // 確認状態の場合に設定するクラス名
    let confirmedClass = '';
    if (extendedProps.confirmed) confirmedClass = 'day-calendar-event-confirmed';
    // キャンセル状態の場合に設定するクラス名
    let canceledClass = '';
    if (extendedProps.canceled) canceledClass = 'day-calendar-event-canceled';

    // 予備足状態の場合の受付番号の追加クラス
    let numberCallingClass = extendedProps.calling ? "number-calling" : '';

    let nameAndOtherText = extendedProps.name;
    if (extendedProps.other) nameAndOtherText += `(${extendedProps.other})`

    let memoText = extendedProps.memo ? extendedProps.memo : '未入力';

    let eventContent = `
      <div 
        class="event-content-${extendedProps.id} event-content-tooltip"
        data-toggle="tooltip"
        data-html="true"
        title="
          <div><b>名前</b>: ${extendedProps.name}</div>
          <div><b>受付内容</b>: ${extendedProps.required_item}</div>
          <div><b>メモ</b>: ${memoText}</div>
        "
      >
        <div class="d-flex justify-content-between" style="margin-bottom: 0.2em;">
          ${statusCard(extendedProps)}
          <div class="d-flex justify-content-around align-items-center">
            ${linkedIcon}
            ${waitTypeIcon}
            ${newArrival}
          </div>
        </div>
        <div class="day-calendar-event ${confirmedClass} ${canceledClass}" data-id="${extendedProps.id}">
          <div class="d-flex">
            <p class="number ${numberCallingClass}">${extendedProps.receipt_number_str}</p>
            <p class="day-calendar-user-name"">${nameAndOtherText}</p>
          </div>
          <p>${extendedProps.hospital_card_number}</p>
          <p>${extendedProps.required_item}</p>
        </div>
      </div>
    `;
    return { html: eventContent }
  };

  static _eventClick() {
    let params = this._extendParams()
    let isModalOpen = this.isModalOpen
    return function (info) {
      if (isModalOpen) return
      isModalOpen = true;

      if (!info.event.id) return
      let stmcCode = location.pathname.split('/')[1];
      $.ajax({
        type: 'GET',
        url: `/${stmcCode}/waitlists/set_calendar_event/${info.event.id}`,
        data: params,
      }).then(function () {
        $('#detailWaitlistModal').modal()
        isModalOpen = false;
      });
    };
  }

  static _eventDrop() {
    let self = this
    return function (eventDropInfo) {
      if (!eventDropInfo.event.id) return

      // 予約時間の変更がある場合のみ確認モーダルを出力する
      if (eventDropInfo.event.start.getTime() != eventDropInfo.oldEvent.start.getTime()) {
        // 確認モーダルを出力
        self._eventDropConfirmModal(eventDropInfo)
      } else {
        self._patchEventEntryTime(eventDropInfo)
      }
    };
  }

  static _patchEventEntryTime(eventInfo) {
    this.set_csrftoken()
    let stmcCode = location.pathname.split('/')[1];
    let params = {
      waitlist: {
        entry_time: eventInfo.event.start
      }
    }

    // スタッフも移動させた場合はその情報も付与する
    if (eventInfo.newResource) {
      params.waitlist.staff_id = eventInfo.newResource.id
    }

    $.ajax({
      type: 'PATCH',
      url: `/${stmcCode}/waitlists/${eventInfo.event.id}/update_entry_time`,
      data: params,
    }).fail(function (e) {
      // リロードしてカレンダーの位置をもとに戻す
      location.reload()
    })
  }

  static _resourceHeaderAddClass() {
    let resourceHeaderInners = document.querySelectorAll(`.${this.resourceHeaderInnerClassName}`);

    let self = this;
    resourceHeaderInners.forEach(function (elem, _) {
      elem.classList.add(self.viewAllResourceHeaderClassName);
    });
  }

  static _selectResource(resources, calendar) {
    // resourceLabelClassNamesで仕込んだクラス名からコマ名が表示されている要素を取得
    let resourceHeaders = document.querySelectorAll(`.${this.resourceHeaderClassName}`);

    let self = this;
    resourceHeaders.forEach(function (elem, _) {
      let handleEventObj = {
        referentTarget: self,
        targetElem: elem,
        resources: resources,
        calendar: calendar,
        handleEvent: self._resourceHeaderClick,
      }
      handleEventObj["handleEventObj"] = handleEventObj;
      // 二度目のクリックの際はイベントリスナーを解除する必要があるため、
      // handleEventObjの中にそのままhandleEventObjを入れ、解除する際に指定する
      elem.addEventListener('click', handleEventObj);
    });
  }

  static _eventDidMount() {
    return function (arg) {
      // 受付ボタンの構造修正
      let addWaitlistBtnEl = arg.el.getElementsByClassName('js-btn-add-waitlist')[0];
      if (addWaitlistBtnEl == null) return;
      [...Array(2)].map(() => $(addWaitlistBtnEl).unwrap());
      arg.el.classList.remove(...arg.el.classList)
      $(addWaitlistBtnEl).parent().css({
        'width': '100%',
        'height': '50px',
        'margin-top': '90px',
      })
    }
  }

  static _addClassUnscheduledStaffResource(calendar) {
    // カレンダーの中の縦軸を取得
    let timegrids = document.querySelectorAll('.fc-timegrid-col');
    timegrids.forEach(function (elem, _) {
      var resource = calendar.getResourceById(elem.dataset.resourceId);
      if (!resource) return;
      if (resource.extendedProps.is_holiday) {
        elem.classList.add("unscheduled-staff-col");
      }
    });
  }

  static _addClassFutureBreaksSlotLane(date, breakTimes) {
    return function (arg) {
      let selectDate = new Date(date)

      // arg.dateに入っている年、月、日がずれているため選択されている日付を入れる
      let tmpDate = arg.date
      tmpDate.setFullYear(selectDate.getFullYear())
      tmpDate.setMonth(selectDate.getMonth())
      tmpDate.setDate(selectDate.getDate())

      let isBreakTime = breakTimes.find((breakTime) => {
        let tmpBreakTime = new Date(breakTime);
        tmpBreakTime.setFullYear(selectDate.getFullYear())
        tmpBreakTime.setMonth(selectDate.getMonth())
        tmpBreakTime.setDate(selectDate.getDate())

        return tmpBreakTime.getTime() == tmpDate.getTime()
      })

      if (!isBreakTime) return;

      return 'break_time'
    }
  }

  static _isSelectedDayToday(selectedDate, currentDate) {
    var selectedYear = selectedDate.getFullYear();
    var selectedMonth = selectedDate.getMonth() + 1;
    var selectedDay = selectedDate.getDate();

    var currentYear = currentDate.getFullYear();
    var currentMonth = currentDate.getMonth() + 1;
    var currentDay = currentDate.getDate();

    if (selectedYear == currentYear) {
      if (selectedMonth == currentMonth) {
        return selectedDay == currentDay;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  static _resourceHeaderClick() {
    // すでにリソースを絞り込んだ状態で再度クリックした場合
    if (this.calendar.getResources().length == 1) {
      // 削除したリソースをリフレッシュして元に戻す
      this.calendar.refetchResources();
      // resouceヘッダーにクラスを当て直す
      this.referentTarget._resourceHeaderAddClass()
      // 縦軸にクラスを当て直す
      this.referentTarget._addClassUnscheduledStaffResource(this.calendar)
      // 絞り込んでいたresourceのヘッダークラスを削除
      let selectedResourceHeader = document.querySelectorAll(`.${this.referentTarget.selectedResourceHeaderClassName}`)[0]
      selectedResourceHeader.classList.remove(this.referentTarget.selectedResourceHeaderClassName);
      // 一つ表示されていたリソースのイベントリスナーを解除
      this.targetElem.removeEventListener('click', this.handleEventObj)
      this.referentTarget._selectResource(this.resources, this.calendar)
      return;
    }

    let self = this;
    this.resources.forEach(function (resource, _) {
      if (self.targetElem.dataset.resourceId != resource.id) {
        let cal_resource = self.calendar.getResourceById(resource.id)
        // リソースを削除する
        if (cal_resource) cal_resource.remove();
      };
    });
    let resourceHeaderInner = document.querySelectorAll(`.${this.referentTarget.resourceHeaderInnerClassName}`)[0];
    resourceHeaderInner.classList.remove(this.referentTarget.viewAllResourceHeaderClassName);
    resourceHeaderInner.classList.add(this.referentTarget.selectedResourceHeaderClassName);
  }

  static _zeroPadding(str) {
    return ('00' + str).slice(-2)
  }

  static _extendParams() {
    return $('#search-params').data('params');
  }

  static _statusCard(extendedProps) {
    let statusCardClass = '';
    if (extendedProps.deleted) {
      statusCardClass = "deleted"
    } else if (extendedProps.canceled) {
      statusCardClass = "canceled"
    } else if (extendedProps.inside) {
      statusCardClass = "type-inside"
    } else if (extendedProps.calling) {
      statusCardClass = "calling"
    }

    let statusCardText = 'ソトマチ中'
    if (extendedProps.deleted) {
      statusCardText = "削除済"
    } else if (extendedProps.canceled) {
      statusCardText = "キャンセル"
    } else if (extendedProps.reservation) {
      statusCardText = "予約中"
    } else if (extendedProps.inside) {
      statusCardText = "ナカマチ中"
    } else if (extendedProps.calling) {
      statusCardText = "呼び出し中"
    }

    // 初診と直来（タブレット予約）の場合はその情報も付与する
    if (extendedProps.current_day_reservation) statusCardText += '(直来)';
    if (extendedProps.first_visit) statusCardText += '(初診)';

    return `
      <div class="calendar-status-card calendar-status-card-${statusCardClass}">
        <div class="status-wrapper">
          <p>${statusCardText}</p>
        </div>
      </div>
    `
  }

  // MEMO:後々確認モーダルが増える場合には命名を変更したり、もっと柔軟に対応できるようロジックを変更する
  // 現在はその想定がないためできるだけシンプルに作成
  static _eventDropConfirmModal(eventInfo) {
    // ナカマチの場合はアラートを表示しない
    if (eventInfo.event.extendedProps.inside) {
      this._patchEventEntryTime(eventInfo)
      return
    }

    let config = {
      showConfirmButton: true,
      showCancelButton: true,
      timer: null,
      allowOutsideClick: true,
      confirmButtonColor: '#16a378',
      cancelButtonText: "いいえ",
      title: '予約日時の変更を行う',
      html: `予約日時を変更しますか？<br> <br>
              変更前日時：${moment(eventInfo.oldEvent.start).format('YYYY/MM/DD HH:mm:ss')}<br>
              変更後日時：${moment(eventInfo.event.start).format('YYYY/MM/DD HH:mm:ss')}<br> <br>
              ※LINEまたはSMSで通知が行われます`,
      confirmButtonText: '変更する'
    };

    let self = this;
    Swal.fire(config).then((e) => {
      if (e.isConfirmed) {
        self._patchEventEntryTime(eventInfo)
      } else {
        // リロードしてカレンダーの位置をもとに戻す
        location.reload()
      };
    });
  }

  static _emrStatusIcon(extendedProps) {
    const emrIntegrationInfo = extendedProps.emr_integration_info;
    const iconClasses = {
      success: 'far fa-check-circle info-icon-check',
      error: 'fas fa-exclamation-circle text-danger fa-lg'
    };

    if (!emrIntegrationInfo && extendedProps.linked) {
      return `<i class="mr-1 ${iconClasses.success}" style="font-size: 20px;"></i>`;
    }

    if (emrIntegrationInfo) {
      if (emrIntegrationInfo.fetch_error || emrIntegrationInfo.link_error || emrIntegrationInfo.cancel_link_error) {
        return `<i class="mr-1 ${iconClasses.error}"></i>`;
      }
      if (emrIntegrationInfo.fetched || emrIntegrationInfo.linked || emrIntegrationInfo.cancel_linked) {
        return `<i class="mr-1 ${iconClasses.success}" style="font-size: 20px;"></i>`;
      }
    }
    return ''
  }

  static set_csrftoken() {
    $.ajaxPrefilter(function (options, _, jqXHR) {
      if (!options.crossDomain) {
        const token = $('meta[name="csrf-token"]').attr('content');
        if (token) {
          return jqXHR.setRequestHeader('X-CSRF-Token', token);
        }
      }
    });
  }
}
